import { createElement, type CSSProperties, type HTMLAttributes } from 'react';
import { useReveal } from '@/hooks/useReveal';

type RevealTag = 'div' | 'li' | 'ul' | 'article' | 'figure' | 'header' | 'p';

export interface RevealProps extends HTMLAttributes<HTMLElement> {
  /** Element to render — pick the tag the layout actually needs. */
  as?: RevealTag;
  /** Stagger, in ms, applied as a transition delay. */
  delay?: number;
}

/** Fades and lifts its children into view on first scroll-in. */
export function Reveal({ as = 'div', delay = 0, style, ...rest }: RevealProps) {
  const ref = useReveal<HTMLElement>();

  return createElement(as, {
    ...rest,
    ref,
    'data-reveal': '',
    style: { ...style, '--reveal-delay': `${delay}ms` } as CSSProperties,
  });
}
